import styled from 'styled-components';

export const StyledContentHubItem = styled.div`
  padding-left: 12px;
  padding-top: 3px;
  color: white;
  font-weight: 100;
  display: block;
  width: 100%;
`;

export const StyledContentHubName = styled.div`
  display: inline-block;
  width: ${({ width }) => width || '50%'};
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  padding-left: 5px;

  @media (min-width: 1200px) {
    width: ${({ width }) => width || '60%'};
  }

  @media (min-width: 1400px) {
    width: ${({ width }) => width || '65%'};
  }
`;

export const StyledContentHubCount = styled.div`
  display: inline-block;
  color: ${({ theme }) => theme.colors.palette[6]};
  vertical-align: middle;
`;

export const ContentHubIcon = styled.div`
  vertical-align: middle;
  background-image: ${({ logo_url }) => `url('${logo_url}')`};
  width: ${({ width }) => width || '25px'};
  height: ${({ height }) => height || '25px'};
  border-radius: 100%;
  background-color: white;
  float: left;
  margin: 0 4px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;

export const ContentHubItemContainer = styled.div`
  display: inline-block;
  width: 100%;
  height: 24px;
  padding: 0 16px 0 0;
  font-size: 12px;
`;
